export const EXPORT_LIMITS = {
    rowsPerFile: 50_000,
    /** Exports one seller may run at once. */
    runningPerSeller: 3,
    /** Files never downloaded are deleted after this many days. */
    unclaimedDays: 7,
    /** Files are deleted this long after their first download. */
    afterDownloadMinutes: 60,
    /**
     * Per person (Saiteja, 28 Oct 2026): exports one person may start in a day, and the gap between
     * two. Failed exports do not count. The API may override both per environment
     * (EXPORT_PER_USER_PER_DAY, EXPORT_MINUTES_BETWEEN).
     */
    perUserPerDay: 5,
    perUserMinutesBetween: 60,
};
//# sourceMappingURL=exports.js.map